import { Checkbox, CheckboxSize } from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import type { InstructionType, UnitInstructions } from "types/landlord/address";
import {
  getSourcePreview,
  INSTRUCTION_TYPE_LABELS,
  INSTRUCTION_TYPES,
  isTypeAvailable
} from "./helpers";

const InstructionTypeTile = ({
  type,
  instructions,
  checked,
  disabled,
  onToggle
}: {
  type: InstructionType;
  instructions: UnitInstructions | null | undefined;
  checked: boolean;
  disabled: boolean;
  onToggle: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const preview = getSourcePreview(instructions, type, dictionary);

  return (
    <div
      className={`flex-1 rounded-lg border p-4 transition-colors ${
        checked ? "border-primary-500 bg-background-900" : "border-alpha-40"
      } ${disabled ? "opacity-60" : ""}`}
    >
      <Checkbox
        checked={checked}
        disabled={disabled}
        id={`apply-instructions-type-${type}`}
        label={INSTRUCTION_TYPE_LABELS[type]}
        onChange={onToggle}
        size={CheckboxSize.SM}
      />
      <p className="mt-2 line-clamp-3 whitespace-pre-wrap pl-6 text-sm text-content-400">
        {preview}
      </p>
    </div>
  );
};

export const InstructionTypeSelector = ({
  instructions,
  selectedTypes,
  onToggleType
}: {
  instructions: UnitInstructions | null | undefined;
  selectedTypes: InstructionType[];
  onToggleType: (type: InstructionType) => void;
}) => (
  <div className="flex items-stretch gap-3">
    {INSTRUCTION_TYPES.map((type) => (
      <InstructionTypeTile
        checked={selectedTypes.includes(type)}
        disabled={!isTypeAvailable(instructions, type)}
        instructions={instructions}
        key={type}
        onToggle={() => onToggleType(type)}
        type={type}
      />
    ))}
  </div>
);
